import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { IMPEGNO_POLITICO_TEMI } from "@/data/impegnoPoliticoData";

export default function ImpegnoPoliticoPage() {
  useEffect(() => {
    document.title = "Impegno Politico | Confcommercio Roma";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" data-testid="impegno-politico-page" className="bg-white">
      {/* Hero */}
      <section className="bg-[var(--confcom-blue)] py-16" data-testid="impegno-politico-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">
            Chi Siamo
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">
            Il Nostro Impegno
          </h1>
        </div>
      </section>

      {/* Introduzione */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-lg text-[var(--confcom-text-primary)] font-semibold font-['Encode_Sans_Semi_Condensed'] leading-relaxed mb-5">
            Confcommercio Roma non è solo un'organizzazione di rappresentanza: è una voce autorevole nel dibattito politico e istituzionale della Capitale e del Paese.
          </p>
          <p className="text-[var(--confcom-text-secondary)] leading-relaxed">
            Nel corso degli anni abbiamo elaborato documenti programmatici, manifesti, dossier e audizioni parlamentari per portare all'attenzione delle istituzioni le istanze del commercio, del turismo, dei servizi e delle professioni. Ogni tema qui raccolto rappresenta una tappa di questo percorso di advocacy: dai grandi appuntamenti elettorali alle riforme costituzionali, dalle strategie per il Centro Storico al rilancio del litorale romano, fino alla visione di un Lazio più competitivo. Un impegno concreto per trasformare le esigenze delle imprese in proposte politiche misurabili.
          </p>
        </div>
      </section>

      {/* Griglia temi */}
      <section className="py-16 bg-[#EBF5FF]" data-testid="impegno-politico-temi-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-8">
            I nostri temi
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {IMPEGNO_POLITICO_TEMI.map((t) => (
              <Link
                key={t.slug}
                to={`/chi-siamo/impegno-politico/${t.slug}`}
                className="group bg-white rounded-xl border border-[var(--confcom-border)] overflow-hidden hover:shadow-lg transition-all flex flex-col"
                data-testid={`impegno-tema-${t.slug}`}
              >
                <div className="h-40 overflow-hidden">
                  <img
                    src={t.cover}
                    alt={t.titolo}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="text-base font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-1 group-hover:text-[var(--confcom-blue)] transition-colors leading-snug">
                    {t.titolo}
                  </h3>
                  <p className="text-xs font-medium text-[var(--confcom-text-muted)] mb-3">
                    {t.sottotitolo}
                  </p>
                  <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">
                    {t.descrizioneBreve}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
